export default {
  api: {
    phoneNumber: {
      exists: "Phone number already exists",

      number: {
        notNull: "Provide a phone number",
      },
      type: {
        notNull: "Select a type",
        found: "Type of phone number already exists",
      },
      idd: {
        notNull: "Select an international direct dialing number (eg: +31)",
      }
    },
  },
}
